import {
  FiBox,
  FiCalendar,
  FiCheckCircle,
  FiPackage,
  FiTruck,
  FiUserCheck,
} from "react-icons/fi";

import ReviewShipmentItem from "./ReviewShipmentItem";
import { miladiToShamsi } from "../../utils/miladiToShamsi";

export default function ReviewShipmentCard({ shipment }) {
  const shippingLabels = {
    carrier: {
      label: "حمل توسط باربری",
      icon: <FiTruck className="h-5 w-5" />,
    },
    supplier: {
      label: "ارسال تأمین‌کننده",
      icon: <FiUserCheck className="h-5 w-5" />,
    },
    pickup: {
      label: "تحویل حضوری",
      icon: <FiPackage className="h-5 w-5" />,
    },
  };

  const method =
    shippingLabels[shipment.selected_option?.method] || {
      label: "روش ارسال نامشخص",
      icon: <FiTruck className="h-5 w-5" />,
    };

  const shippingCost = Number(
    shipment.selected_option?.calculated_delivery_cost || 0
  );

  const shipmentTotal = Number(shipment.total_amount || 0);

  return (
    <article className="overflow-hidden rounded-2xl border border-slate-100 bg-white shadow-sm">
      <header className="border-b border-slate-100 bg-gradient-to-l from-slate-50 to-white px-5 py-5 sm:px-6">
        <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
          <div className="flex items-center gap-3">
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-blue-50 text-[#1E3A5F]">
              <FiBox className="h-5 w-5" />
            </div>

            <div>
              <p className="text-xs font-medium text-slate-400">
                تأمین‌کننده
              </p>
              <h3 className="mt-1 font-bold text-slate-800">
                {shipment.supplier?.name || "-"}
              </h3>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-3 text-sm sm:grid-cols-3 lg:flex lg:items-center lg:gap-6">
            <div className="flex items-center gap-2 text-slate-600">
              <span className="text-[#1E3A5F]">{method.icon}</span>
              <div>
                <p className="text-[11px] text-slate-400">روش ارسال</p>
                <p className="mt-0.5 font-semibold">{method.label}</p>
              </div>
            </div>

            <div className="flex items-center gap-2 text-slate-600">
              <FiCalendar className="h-5 w-5 text-[#1E3A5F]" />
              <div>
                <p className="text-[11px] text-slate-400">زمان تحویل</p>
                <p className="mt-0.5 font-semibold">
                  {shipment.selected_option?.estimated_delivery_date
                    ? miladiToShamsi(
                        shipment.selected_option.estimated_delivery_date
                      )
                    : "-"}
                </p>
              </div>
            </div>

            <div className="flex items-center gap-2 text-slate-600">
              <FiCheckCircle className="h-5 w-5 text-[#1E3A5F]" />
              <div>
                <p className="text-[11px] text-slate-400">وزن محموله</p>
                <p className="mt-0.5 font-semibold">
                  {shipment.total_weight || 0} کیلوگرم
                </p>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="hidden grid-cols-12 gap-4 border-b border-slate-100 bg-slate-50 px-6 py-3 text-xs font-semibold text-slate-400 md:grid">
        <div className="col-span-6">کالا</div>
        <div className="col-span-2 text-center">قیمت واحد</div>
        <div className="col-span-1 text-center">تخفیف</div>
        <div className="col-span-1 text-center">تعداد</div>
        <div className="col-span-2 text-left">مبلغ کل</div>
      </div>

      <div className="divide-y divide-slate-100">
        {shipment.items?.map((item) => (
          <ReviewShipmentItem key={item.product_id} item={item} />
        ))}
      </div>

      <footer className="flex flex-col gap-3 border-t border-slate-100 bg-slate-50 px-5 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-6">
        <div className="text-sm text-slate-500">
          هزینه ارسال:{" "}
          <span className="font-bold text-slate-700">
            {shippingCost.toLocaleString("fa-IR")} تومان
          </span>
        </div>

        <div className="flex items-center gap-2">
          <span className="text-sm text-slate-500">قیمت کل محموله:</span>
          <span className="text-base font-bold text-[#1E3A5F]">
            {shipmentTotal.toLocaleString("fa-IR")} تومان
          </span>
        </div>
      </footer>
    </article>
  );
}
